
export default {
  name: 'ParallaxOne',
  props: {
    image: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 0.5,
    },
  },
  data() {
    return {
      yOffset: 0,
      ticking: false,
      lastScrollY: 0,
    }
  },
  mounted() {
    this.lastScrollY = window.pageYOffset
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.updateParallax() // İlk yükleme için
    
    // Resmin yüklenmesini bekle
    const img = new Image()
    img.src = this.image
    img.onload = () => {
      this.updateParallax()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.lastScrollY = window.pageYOffset
      this.requestTick()
    },
    requestTick() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateParallax()
          this.ticking = false
        })
        this.ticking = true
      }
    },
    updateParallax() {
      const rect = this.$refs.container.getBoundingClientRect()
      const scrolled = window.pageYOffset
      const containerTop = rect.top + scrolled
      const viewportHeight = window.innerHeight
      
      // Element viewport'ta görünür olduğunda
      if (containerTop < scrolled + viewportHeight && 
          containerTop + rect.height > scrolled) {
        // Daha yumuşak hareket için lerp (linear interpolation) kullan
        const targetOffset = (scrolled - containerTop) * this.speed
        const currentOffset = this.yOffset
        const diff = targetOffset - currentOffset
        
        this.yOffset = currentOffset + (diff * 0.1) // Yumuşak geçiş için
      }
    },
  },
}
